<template>
  <div>
    <div style="padding-bottom: 22px">
      <div class="upload-list" v-for="item in uploadList" :key="item.uid">
        <template v-if="item.status === 'success' || item.status === 'finished'">
          <img :src="isPdf(item.url) ? pdfIcon : item.url" width="107px" height="107px" />
          <div class="upload-list-cover">
            <i class="el-icon-view" @click="handleView(item.url)"></i>
            <i class="el-icon-delete" @click="handleRemove(item)"></i>
          </div>
        </template>
        <template v-else>
          <el-progress v-if="item.showProgress" :percentage="convertPercent(item)" :show-text="false"></el-progress>
        </template>
      </div>
      <el-upload
        ref="upload"
        v-show="uploadList.length < max"
        :action="host + uploadUrl"
        :show-file-list="false"
        :on-success="handleSuccess"
        :before-upload="imageUploader"
        :file-list="uploadList"
        multiple
        with-credentials
        drag
        class="upload-box"
        style="display: inline-block; width: 107px"
      >
        <div style="width: 107px; height: 107px; line-height: 107px">
          <i class="el-icon-plus" style="font-size: 34px"></i>
        </div>
      </el-upload>
    </div>

    <!-- 素材预览框 -->
    <el-dialog title="素材预览" :visible.sync="visible" :footer="null">
      <img v-if="isPdf(preview_url)" :src="pdfIcon" style="width: 100%" />
      <img v-else-if="imageType === 1" :src="preview_url" style="width: 100%" />
      <video ref="video" v-else autoplay controls="controls" style="width: 100%; height: 360px" :src="preview_url">
        您的浏览器不支持 video 标签。
      </video>
    </el-dialog>
  </div>
</template>

<script>
import { isArray } from '@/common/js/utils'
import { HOST_API } from '@/api/config'

export default {
  name: 'appUpload',
  props: {
    value: {
      type: String
    },
    host: {
      type: String,
      default: HOST_API
    },
    uploadUrl: {
      type: String
    },
    max: {
      // 最大上传个数
      type: Number,
      default: 1
    },
    imageType: {
      // 1：图片，2：视频, 3: pdf
      type: Number,
      default: 1
    },
    allowType: {
      // 允许素材类型
      type: Array,
      default: () => ['image/png', 'image/gif', 'image/jpeg']
    },
    maxSize: {
      // 单位M
      type: Number,
      default: 10
    },
    imageSize: {
      type: Array,
      default: () => []
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    urls: {
      get() {
        return this.value
      },
      set(nVal) {
        this.$emit('input', nVal)
      }
    },
    isPdf() {
      return (preview_url) => {
        if (preview_url && preview_url.split('.').length > 1) {
          const split = preview_url.split('.')
          return split[split.length - 1].toLocaleLowerCase() === 'pdf'
        }
        return false
      }
    }
  },
  watch: {
    visible(val) {
      if (this.imageType === 2 && !val) {
        // 关闭弹窗暂停播放
        this.$refs.video.pause()
      }
    },
    uploadList: {
      // 监控文件上传进度-构建假进度条，默认到70%时开始构建
      handler(nVal) {
        const over70File = nVal.filter((ret) => ret.percentage >= 70)
        over70File.forEach((ret) => {
          const idx = this.uploadList.indexOf(ret)
          if (!this.progressCollect[`${ret.uid}_percentage`]) {
            // 无计数器则添加
            this.$set(this.progressCollect, `${ret.uid}_percentage`, 70)
          }
          if (!this.progressCollect[`${ret.uid}_time`]) {
            // 无计时器则添加
            this.progressCollect[`${ret.uid}_time`] = setInterval(() => {
              const nVal = this.progressCollect[`${ret.uid}_percentage`] >= 100 ? 100 : this.progressCollect[`${ret.uid}_percentage`] + 1
              this.uploadList[idx] && this.$set(this.uploadList[idx], 'percentage', nVal)
              this.$set(this.progressCollect, `${ret.uid}_percentage`, nVal)
            }, 1000)
          }
          if (ret.status === 'success' || ret.status === 'finished') {
            // 完成时移除计数器、计时器
            this.uploadList[idx] && this.$set(this.uploadList[idx], 'percentage', 100)
            clearInterval(this.progressCollect[`${ret.uid}_time`])
            this.$set(this.progressCollect, `${ret.uid}_time`, undefined)
            this.$set(this.progressCollect, `${ret.uid}_percentage`, undefined)
          }
        })
        if (nVal.length > 0 && nVal.every((ret) => ret.status === 'success' || ret.status === 'finished')) {
          // 所有上传任务完成
          // Element UI upload response structure might be different, let's check
          this.urls = nVal.map((ret) => (ret.response && ret.response.data ? ret.response.data.url : ret.url)).join(',')
        }
      },
      deep: true
    },
    urls() {
      // this.uploadList.splice(0, this.uploadList.length)
      // this.setValue()
      // Element UI handles file-list prop sync, but if we change urls from parent or initial load, we need to sync back.
      // However, modifying uploadList directly while it's bound to el-upload might be tricky.
      // Let's rely on watch value change to init.
    },
    value(val) {
      if (val) {
        const urls = val.split(',')
        // Avoid infinite loop if values are same
        const currentUrls = this.uploadList.map((item) => item.url).join(',')
        if (currentUrls !== val) {
          this.uploadList = urls.map((url, index) => ({
            name: `file-${index}`,
            url: url,
            status: 'success',
            uid: Date.now() + index
          }))
        }
      } else {
        this.uploadList = []
      }
    }
  },
  methods: {
    // 上传成功回调
    handleSuccess(res, file, fileList) {
      if (res.code !== 200) {
        this.$message.error(file.name + ',上传失败,' + res.msg)
        // this.handleRemove(file) // Element UI automatically adds it, we need to remove it from list
        const idx = this.uploadList.findIndex((item) => item.uid === file.uid)
        if (idx > -1) this.uploadList.splice(idx, 1)
        return
      }
      this.uploadList = fileList // Sync list

      for (let i = this.waitDelImage.length - 1; i >= 0; i--) {
        // 删除未通过检验的图片
        this.handleRemove(this.waitDelImage[i])
        this.waitDelImage.splice(i, 1)
      }
      const isMatch = (ret) => {
        return ret.response && ret.response.data.signature === file.response.data.signature
      }
      // Check duplicates
      const matchData = this.uploadList.filter((ret) => isMatch(ret))
      if (isArray(matchData) && matchData.length > 1) {
        this.handleRemove(file)
      }
    },
    handleView(url) {
      this.preview_url = url
      if (this.preview) {
        if (this.isPdf(url)) window.open(url)
        else this.visible = true
      } else window.open(url)
    },
    handleRemove(file) {
      // const fileList = this.$refs.upload.fileList
      // this.$refs.upload.fileList.splice(fileList.indexOf(file), 1)
      // Element UI: update uploadList
      const idx = this.uploadList.indexOf(file)
      if (idx > -1) {
        this.uploadList.splice(idx, 1)
      }
      // If we manually update uploadList, we should also update urls
      if (this.uploadList.length === 0) {
        this.urls = ''
      } else {
        this.urls = this.uploadList.map((ret) => (ret.response && ret.response.data ? ret.response.data.url : ret.url)).join(',')
      }
    },
    imageUploader(file) {
      if (this.uploadList.length > this.max - 1) {
        this.$message.error(`批量上传单次最多${this.max}个素材`)
        return false
      }
      const { size, name, type } = file
      if (!this.allowType.includes(type)) {
        this.$message.error({
          showClose: true,
          duration: 5000,
          message: `上传的图片 ${name} 格式错误，只支持 ${this.allowType.join(',')} 格式 `
        })
        return false
      }
      if (size > 1024 * 1024 * this.maxSize) {
        this.$message.error({
          showClose: true,
          duration: 5000,
          message: `上传的图片 ${name} 超过限制大小 ${this.maxSize}M`
        })
        return false
      }
      if (isArray(this.imageSize) && this.imageSize.length === 2) {
        const [x, y] = this.imageSize
        // We need to return a Promise to hold off upload if we want to check dimensions asynchronously
        // But before-upload expects boolean or Promise.
        return new Promise((resolve, reject) => {
          this.getFileInfo(file)
            .then((data) => {
              const { width, height } = data
              if (width < x || height < y) {
                this.waitDelImage.push(file)
                this.$message.error({
                  showClose: true,
                  duration: 5000,
                  message: `上传的图片 ${name} 尺寸不符合要求`
                })
                // Element UI: if we reject, upload stops.
                reject(new Error('图片尺寸不符合要求'))
              } else {
                resolve()
              }
            })
            .catch((err) => {
              this.$message.error({
                showClose: true,
                duration: 5000,
                message: `读取文件信息出错： ${err}`
              })
              reject(new Error(err))
            })
        })
      }
      return true
    },
    convertPercent(file) {
      // 构造假进度条
      return this.progressCollect[`${file.uid}_percentage`] || file.percentage
    },
    getFileInfo(file) {
      const reader = new FileReader()
      const image = new Image()
      return new Promise((resolve, reject) => {
        reader.onload = function (e) {
          const data = e.target.result
          image.onload = function () {
            const width = image.width
            const height = image.height
            resolve({ width, height })
          }
          image.src = data
        }
        reader.readAsDataURL(file)
      })
    },
    setValue() {
      if (this.value) {
        const urls = this.value.split(',')
        this.uploadList = urls.map((ret, index) => ({
          name: `file-${index}`,
          url: ret,
          status: 'success',
          uid: Date.now() + index
        }))
      }
    }
  },
  data() {
    return {
      visible: false,
      preview_url: '',
      uploadList: [],
      progressCollect: {}, // 上传进度集合,
      waitDelImage: [],
      pdfIcon: 'https://ptom-resource-cos.caohua.com/ptom/advResource/app/db4edc9875e2b0f4f48a0933103117e6.jpg'
    }
  },
  mounted() {
    this.setValue()
  }
}
</script>

<style lang="scss">
.upload-list {
  display: inline-block;
  width: 109px;
  height: 109px;
  text-align: center;
  line-height: 109px;
  border-radius: 4px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.5);
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
  margin-right: 4px;
  vertical-align: top;

  img {
    width: 100%;
    height: 100%;
  }
}

.upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}

.upload-list:hover .upload-list-cover {
  display: block;
}

.upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
  line-height: 109px;
}

.upload-box {
  .el-upload-dragger {
    width: 107px;
    height: 107px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    &:hover {
      border-color: #409eff;
    }
  }
}
</style>
